/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  maps: [],
  limit: 5,
};

const getters = {
  maps: state => state.maps,
  limit: state => state.limit,
};

const actions = {
  fetch({ commit }, payload) {
    const limit = `&limit=${payload.limit ? payload.limit : state.limit}`;
    let keyword = '';
    if (payload.keyword) {
      keyword = `&q=${payload.keyword}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/maps/list?${keyword}${limit}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, maps) {
    state.maps = maps.data;
  },
  [mTypes.EDIT_DATA](state, updatedMap) {
    const index = state.maps.items.findIndex(obj => obj.id === updatedMap.id);
    if (index !== -1) {
      state.maps.items[index].name = updatedMap.name;
    } else {
      state.maps.items.unshift(updatedMap);
      state.maps.total += 1;
    }
  },
  [mTypes.SET_LIMIT](state, limit) {
    state.limit = limit;
  },
  [mTypes.REMOVE_DATA](state, mapItemId) {
    const index = state.maps.items.findIndex(obj => obj.id === mapItemId);
    state.maps.items.splice(index, 1);
    state.maps.total -= 1;
  },
  [mTypes.CLEAR_STATE](state) {
    state.maps = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/maps.js